<template>
  <div class="customer-page-asset position-relative rounded">
    <UeVerifiedBadge v-if="showVerifiedBadge" class="verified-badge" />
    <section v-for="section in customerPageAsset.sections" :key="section.id">
      <AssetLibrarySection
        v-if="section.type === 'asset_library'"
        :settings="section.settings"
        :account="customerPageAsset.account"
      />
      <component
        v-else
        :is="componentMap[section.type]"
        :settings="section.settings"
        :content="section.content"
      />
    </section>
  </div>
</template>

<script setup lang="ts">
import { computed, type Component } from 'vue'
import { CustomerPageAsset } from '@/types/CustomerPageAsset'
import UeVerifiedBadge from '@components/customer_page/UeVerifiedBadge.vue'
import HeroSection from '@components/customer_page/sections/HeroSection.vue'
import StatsSection from '@components/customer_page/sections/StatsSection.vue'
import TestimonialSection from '@components/customer_page/sections/testimonials/TestimonialsSection.vue'
import LogoSection from '@components/customer_page/sections/logos/LogosSection.vue'
import TextSection from '@components/customer_page/sections/text/TextSection.vue'
import AssetLibrarySection from '@components/customer_page/sections/asset_library/AssetLibrarySection.vue'
import { getColorById } from './customer_page/sections/utils'

interface Props {
  customerPageAsset: CustomerPageAsset
}

const props = defineProps<Props>()

const componentMap: Record<string, Component> = {
  hero: HeroSection,
  stat: StatsSection,
  testimonial: TestimonialSection,
  logo: LogoSection,
  text: TextSection,
}

const showVerifiedBadge = computed(() => {
  return props.customerPageAsset?.settings?.show_ue_badge
})

const pageBackgroundColor = computed(() => {
  return (
    getColorById(props.customerPageAsset.settings?.design_settings?.colors, 'background_color') ||
    '#ffffff'
  )
})
</script>

<style lang="sass" scoped>
.customer-page-asset
  padding: 2.5rem 1.25rem 1.25rem
  background-color: v-bind(pageBackgroundColor)
  width: 100%
  margin: 0px auto
  max-width: 1000px
  section
    margin-bottom: 2rem

  .verified-badge
    position: absolute
    top: 20px
    right: 50%
    transform: translateX(50%)
</style>
